export const facebookConfig = {
	metaImage: {
		url: '/content/space-default',
		type: 'image/jpeg',
		width: 1200,
		height: 628,
	},
} as const
